import React, { useEffect } from "react";
import { Switch } from "@/compat/router";
import { useTracking } from "react-tracking";
import AuthLayout from "../layouts/AuthLayout";
import trackingService from "../services/trackingService";
import trackingConstants from "../constants/trackingConstants";
import { protectedRoutes } from "../routes";
import { MuiPickersUtilsProvider } from "@/compat/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { SnackbarProvider as VendingMachine } from "notistack";
import RouteMapper from "./RouteMapper";
import { useAuth } from "../contexts/authContext";
import { isHRS } from "../constants/siteConfig";

const AuthenticatedApp = () => {
    const { impersonatingUser, user } = useAuth();
    const { Track } = useTracking(
        {
            app: trackingConstants.appName,
            isImpersonationSession: !!impersonatingUser,
        },
        {
            dispatch: trackingService.sendTrackingData,
            process: (ownTrackingData) =>
                ownTrackingData.page
                    ? { event: trackingConstants.events.pageView }
                    : null,
        }
    );

    useEffect(() => {

        if (isHRS)
            return;

        var decodedRoles = Array.isArray(user.details.roles) ? user.details.roles : user.details.roles !== undefined ? [user.details.roles] : [];
        var decodedApps = Array.isArray(user.details.apps) ? user.details.apps : user.details.apps !== undefined ? [user.details.apps] : [];

        let roles = decodedRoles.length === 0 ? [] : decodedRoles.map(role => role.split(':')[0]);
        let apps = decodedApps.length === 0 ? [] : decodedApps.map(role => role.split(':')[0]);

        (window as any).InlineManual("boot", { name: user.details.firstName, uid: user.details.email, roles, apps }, { language: 'en' });
        (window as any).InlineManual("update");

        return () => {
            (window as any).InlineManual("shutdown");
        }
    }, [user]);

    return (
        <Track>
            <VendingMachine maxSnack={3}>
                <AuthLayout>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <RouteMapper routes={protectedRoutes} />
                    </MuiPickersUtilsProvider>
                </AuthLayout>
            </VendingMachine>
        </Track>
    );
};

export default AuthenticatedApp;
